import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme) {
  var mp = '@media print';
  return {
    content: _defineProperty({
      flex: '1',
      flexDirection: 'column',
      backgroundColor: componentTheme.alertBackground,
      borderColor: componentTheme.borderColor,
      borderWidth: '3px 3px 0 3px',
      borderStyle: 'solid'
    }, mp, {
      border: 'none',
      overflow: 'visible !important'
    })
  };
};
export default generateStyle;